export default __webpack_public_path__ + "static/media/exit.17e42315.mp3";